// -------------------------------------
//   SlickSlider
// -------------------------------------

jQuery(document).ready(function ($) {
    // Lazyload responsive images
    // $(document).on('init breakpoint', '#slick-banner', function(event){
    //     var slideSources = $('.slick-slide').find('source');
    //     $(slideSources).each(function () {
    //         $(this).attr('srcset', $(this).data('lazy'));
    //     });
    // });

    $('#slick-banner').slick({
        fade: false,
        arrows: true,
        dots: false,
        lazyLoad: 'progressive',
        adaptiveHeight: true,
        autoplay: true,
        autoplaySpeed: 5000,
    });

    $('#slick-area').slick({
        infinite: true,
        speed: 300,
        arrows: true,
        appendArrows: $("#slick-area-arrows"),
        dots: false,
        lazyLoad: 'progressive',
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        adaptiveHeight: true,
        swipeToSlide: true,
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 840,
                settings: {
                    slidesToShow: 1,
                }
            },
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    });

    $('#slick-equipe').slick({
        fade: false,
        arrows: true,
        appendArrows: $("#slick-equipe-arrows"),
        dots: false,
        lazyLoad: 'progressive',
        adaptiveHeight: true,
        autoplay: false,
        autoplaySpeed: 5000,
    });

    $(".depoimento-slider").slick({
        autoplay: true,
        autoplaySpeed: 5000,
        centerMode: true,          
        focusOnSelect: true, 
        swipeToSlide: true,
        variableWidth: true,
        adaptiveHeight: true,
        lazyLoad: "progressive",
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    centerPadding: '30px',
                    variableWidth: false,
                }
            },
        ]
    });
});

//# sourceMappingURL=data:application/json;charset=utf8;base64,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
